import FlatList from "src/components/FlatList";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import UserListItem from "src/components/team/users/UserListItem";
import useUsers from "src/hooks/api/services/users/useUsers";

interface UserListProps extends Translation {
	children?: any;
	selectedTeam?: string;
}

const UserList = ({ t, selectedTeam }: UserListProps) => {
	const { users, status } = useUsers();

	const headers = [
		t("headers.status"),
		t("headers.name"),
		t("headers.team"),
		t("headers.created-at"),
		"",
	];
	return (
		<FlatList
			loading={status === "loading" && !users?.length}
			data={
				selectedTeam
					? users.filter((user) =>
							(user?.teams || []).includes(selectedTeam)
					  )
					: users
			}
			variant="flat"
			table={{
				headers,
			}}
			empty={{
				title: t("empty.title"),
				text: t("empty.text"),
			}}
			renderItem={(item) => (
				<UserListItem user={item} key={`user-${item.id}`} />
			)}
		/>
	);
};

UserList.locale = {
	nl: {
		headers: {
			status: "Status",
			name: "Naam",
			team: "Team",
			"created-at": "Aangemaakt op",
		},
		empty: {
			title: "Geen gebruikers gevonden",
			text: "We hebben geen gebruikers kunnen vinden voor dit account.",
		},
	},
	en: {
		headers: {
			status: "Status",

			name: "Name",
			team: "Team",
			"created-at": "Created at",
		},
		empty: {
			title: "No users found",
			text: "We are not able to find any users for this account.",
		},
	},
};

export default withTranslation(UserList);
